/**
 * Where the homeowner portal lives, from this app's point of view.
 *
 * `VITE_MEMBER_PORTAL_URL` already exists for this: the chart sets it on
 * the front-porch Deployment and `start-front-porch-app.sh` writes it
 * into `window._env_` at container start, so every namespace points at
 * its own portal without a rebuild — the same mechanism `workosConfig.ts`
 * uses for the WorkOS client id. A second key naming the same thing would
 * be one more value to keep in step.
 *
 * Falls back to `http://localhost:3001`, which is where
 * `docker-compose.yml` and the browser-verify skill both put it. Unlike
 * the WorkOS client id there *is* a sensible local default here: getting
 * it wrong opens a window at the wrong address, which is obvious, rather
 * than failing as "invalid credentials", which is not.
 */
export function memberPortalOrigin(): string {
  const configured = window._env_?.VITE_MEMBER_PORTAL_URL;
  const value = typeof configured === 'string' ? configured.trim() : '';
  return (value || 'http://localhost:3001').replace(/\/$/, '');
}

/**
 * The URL that opens a read-only view of a homeowner's portal.
 *
 * **The token goes in the fragment, never the query string.** A fragment
 * is the one part of a URL a browser does not send to a server, so it
 * reaches no access log, no proxy trace and no `Referer` header. The
 * landing page strips it from the address bar on arrival.
 */
export function impersonationUrl(accessToken: string): string {
  return `${memberPortalOrigin()}/impersonate#token=${encodeURIComponent(
    accessToken
  )}`;
}
